import { noop } from 'lodash-es';
import { UserManager as OidcUserManager, SigninResponse, UserManagerSettings } from 'oidc-client-ts';

import { InAppBrowserNavigator, isInAppBrowserAvailable } from '../../../utils/cordova';

/**
 * AppFrameUserManager will change RedirectNavigator and IFrameNavigator to InAppBrowserNavigator
 * if the application use cordova.InAppBrowser.
 */
class UserManager extends OidcUserManager {
  private _signInResponse: SigninResponse | null = null;

  public getSignInResponse() {
    return this._signInResponse;
  }

  public constructor(settings: UserManagerSettings) {
    super(settings);
    if (isInAppBrowserAvailable()) {
      // @ts-expect-error
      this._redirectNavigator = new InAppBrowserNavigator(false);
      // @ts-expect-error
      this._iframeNavigator = new InAppBrowserNavigator(true);
    }

    // We have to override the `validateSigninResponse` to capture the signin response on error
    // This is needed to get the id_token for logout when sign-in fails

    // @ts-expect-error
    const validator = this._client?._validator ?? noop;
    const validateSigninResponseOriginal = validator.validateSigninResponse;
    validator.validateSigninResponse = async (response, state) => {
      try {
        return await validateSigninResponseOriginal.bind(validator)(response, state);
      } catch (err: unknown) {
        this._signInResponse = response;
        throw err;
      }
    };
  }
}

export default UserManager;
